export default "{\n    \"suspended\": \"Suspendu\"\n}\n"